module.exports = __webpack_public_path__ + "media/MRI-ExemploB.7c27e71e.mp3";